<template>
  <canvas id="chart" ref="myChart"></canvas>
</template>

<script>
import Chart from 'chart.js';

export default {
  props: ['data', 'labels', 'title', 'type', 'xAxis', 'yAxis', 'dataset', 'isMixed', 'isStacked'],
  name: 'myChart',
  mounted() {
    // console.log(this.type + ' - ' + this.title + ' - ' + this.isMixed + ' - ' + this.isStacked);
    // console.log(this.labels)
    // console.log(this.dataset);
    new Chart(this.$refs.myChart, {
      type: this.type,
      data: {
        // labels: [ 'Dove and Soap', 'Engineering', 'Fatty Acid', 'Finance', 'Human Resource', 'Logistics', 'Marvel Project', 'Other', 'Planner', 'Procurement', 'Quality Assurance', 'Sales' ],
        labels: this.labels,
        datasets: (this.type === 'pie' && !this.isMixed) ? 
          [{
            data: this.data,
            backgroundColor: ['rgba(240, 240, 0, 1)', 
            'rgba(11, 214, 0, 1)',
            'rgba(219, 0, 0, 1)',
            'rgba(4, 49, 231, 1)',
            'rgba(6, 174, 0, 1)', 
            'rgba(255, 149, 10, 1)', 
            'rgba(255, 235, 10, 1)', 
            'rgba(150, 162, 187, 1)', 
            'rgba(10, 239, 255, 1)', 
            'rgba(10, 153, 255, 1)', 
            'rgba(175, 153, 255, 1)', 
            'rgba(176, 0, 230, 1)',
            'rgba(153, 0, 127, 1)',
            'rgba(255, 163, 163, 1)',
            'rgba(255, 10, 10, 1)',
            'rgba(55, 41, 255, 1)',
            'rgba(79, 32, 167, 1)',
            'rgba(175, 219, 118, 1)',
            'rgba(27, 175, 192, 1)']
          }]
          : (this.type === 'line' && !this.isMixed) ? 
          [{
            data: this.data,
            backgroundColor: 'rgba(65, 131, 215, 1)',
            borderColor: 'rgba(65, 131, 215, 1)',
            label: this.title,
            fill: false,
          }]
          : (this.type === 'bar' && !this.isMixed  && !this.isStacked) ? 
          [{
            data: this.data,
            backgroundColor: 'rgba(65, 131, 215, 1)',
            borderColor: 'rgba(65, 131, 215, 1)',
            label: this.title,
            fill: false,
          }]
          : (this.type === 'bar' && this.isMixed && !this.isStacked) ? 
          this.dataset
          : (this.type === 'bar' && !this.isMixed && this.isStacked) ? 
          this.dataset
          : 
          [],
      },
      options: (this.type === 'pie' && !this.isMixed) ? 
        {
          responsive: true,
          title: {
            display: true,
            text: this.title
          },
          legend: {
            display: true,
            position: 'right',
          }
        }
      : (this.type === 'line' && !this.isMixed) ?
        {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.title
        },
        tooltips: {
          mode: 'label',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.xAxis
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.yAxis
            },
            ticks: {
              precision:0
            },
          }]
        }
      }
      : (this.type === 'bar' && !this.isMixed && !this.isStacked) ?
      {
        responsive: false,
        scales: {
          xAxes: [{
            ticks: {
              maxRotation: 90,
              minRotation: 80
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
      : (this.type === 'bar' && this.isMixed && !this.isStacked) ?
      {
        responsive: true,
        scales: {
          xAxes: [{
            ticks: {
              maxRotation: 0,
              minRotation: 60,
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        title: {
          display: true,
          text: this.title,
        }
      }
      : (this.type === 'bar' && !this.isMixed && this.isStacked) ?
      {
        tooltips: {
          displayColors: true,
          callbacks:{
            mode: 'x',
          },
        },
        responsive: true,
        legend: {
          position: 'top' // place legend on the right side of chart
        },
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
            type: 'linear',
          }]
        },
        title: {
          display: true,
          text: this.title,
        }
      }
      :
      {
        
      }
    });
  }
}
</script>

<style>
#chart {
  border: 3px;
  border-color: blue;
}
</style>